import { DBDef_RuntimeSmartNote } from '@app/advisor-shared';
import { ModuleFE_BaseAdvisorRuntime } from '../../../modules/ModuleFE_BaseAdvisorRuntime.js';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { sendValidateCacheMessage } from '../../../index.js';
import { convert_SmartNote } from './utils.js';
import { sortArray } from '@nu-art/ts-common';
import { ModuleFE_AdvisorSession } from '../../advisor-session/index.js';
export const dispatch_onRuntimeSmartNotesUpdated = new ThunderDispatcherV3('__onRuntimeSmartNotesUpdated');
export class ModuleFE_RuntimeSmartNote_Class extends ModuleFE_BaseAdvisorRuntime {
    __validateCache = () => {
        const moduleName = this.getName();
        const encounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
        const invalidSmartNotes = this.cache.filter(note => note.encounterId !== encounterId);
        if (!invalidSmartNotes.length)
            return this.logDebug(`${moduleName} cache is valid`);
        this.logErrorBold(`${moduleName} has invalid data in cache`, invalidSmartNotes);
        return sendValidateCacheMessage(invalidSmartNotes, moduleName);
    };
    constructor() {
        super(DBDef_RuntimeSmartNote, dispatch_onRuntimeSmartNotesUpdated);
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.encounterFilter);
    }
    convertNoteToTextBlob(_note, ignoreSelection = false, options) {
        const note = typeof _note === 'string' ? this.cache.unique(_note) : _note;
        if (!note)
            return;
        return convert_SmartNote(note, ignoreSelection, options);
    }
    getLatestNote = (templateId) => {
        if (!templateId)
            return;
        const notes = this.cache.filter(note => note.templateId === templateId);
        sortArray(notes, note => note.__created, true);
        return notes[0];
    };
}
export const ModuleFE_RuntimeSmartNote = new ModuleFE_RuntimeSmartNote_Class();
//# sourceMappingURL=ModuleFE_RuntimeSmartNote.js.map